module.exports = __webpack_public_path__ + "static/media/sayingitdontmakeitso.546c7eb6.png";